const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2550",
    d: "M1 12a27.833 27.833 0 0 0 .462 5.827A6.193 6.193 0 0 0 3 21a6.193 6.193 0 0 0 3.172 1.54A27.838 27.838 0 0 0 12 23a27.838 27.838 0 0 0 5.827-.462A6.193 6.193 0 0 0 21 21a6.193 6.193 0 0 0 1.54-3.172A27.838 27.838 0 0 0 23 12a27.838 27.838 0 0 0-.462-5.827A6.193 6.193 0 0 0 21 3a6.193 6.193 0 0 0-3.172-1.54A27.833 27.833 0 0 0 12 1a27.833 27.833 0 0 0-5.827.462A6.193 6.193 0 0 0 3 3a6.193 6.193 0 0 0-1.54 3.172A27.833 27.833 0 0 0 1 12z",
    style: {
      strokeLinecap: "round",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Tracciato 2551",
    d: "m11.158 8.182 1.762-1.848a1.092 1.092 0 0 1 1.519-.052l3.219 2.934a1.034 1.034 0 0 1 .053 1.485l-1.893 1.985m-4.661-4.5-4.868 5.102a1.037 1.037 0 0 0-.289.786l.2 2.945A1.065 1.065 0 0 0 7.279 18l3.019-.011a1.087 1.087 0 0 0 .782-.334l4.738-4.968m-4.661-4.5 4.661 4.5",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f14720b027c87aec13ec4d30868ed214.svg";
export { ForwardRef as ReactComponent };